module.exports = __webpack_public_path__ + "files/90dd88f2fda35e33bd934a80f2779d67.svg";